import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

// Works in vanilla react, imported from mdbootstrap/react/lightbox/jsx-lighbox
//import Lightbox from "react-image-lightbox";
import "./Lightbox.css";

class LightboxPage extends React.Component {
state = {
  photoIndex: 0,
  isOpen: false,
  images: [
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/smil2_nbk_2019-16-9.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/smilab9.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/smilab10.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/84070487_2775866529147053_7703846670915600384_o.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/70963339_2492183264182049_4034029908006010880_o.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/02/86671203_2820019784731727_2620443483835465728_o.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/01/70963339_2492183264182049_4034029908006010880_o.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/02/86671203_2820019784731727_2620443483835465728_o.jpg',
    'https://smorasstats.com/v4/wp-content/uploads/2020/02/86871790_2820016574732048_4843403476891336704_o.jpg'
    
  ]
}

renderImages = () => {
  let photoIndex = -1;
  const { images } = this.state;

return images.map(imageSrc => {
  photoIndex++;
  const privateKey = photoIndex;
  return (
    <MDBCol md="4" key={photoIndex}>
      <figure className="lightbox-item">
        <a href={imageSrc} >
          <img src={imageSrc} alt="Gallery" className="img-fluid"/>
        </a>
      </figure>
    </MDBCol>
    );
  })
}

render() {
const { photoIndex, isOpen, images } = this.state;
  return (
      <MDBContainer>
        <div className="mdb-lightbox no-margin">
          <MDBRow>
            {this.renderImages()}
          </MDBRow>
        </div>
      </MDBContainer>
    );
  }
}

export default LightboxPage;